module.exports = __webpack_public_path__ + "img/smile.9dba0327.svg";